import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, Mail, MapPin, MessageCircle } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/equipment", label: "Equipment & Fleet" },
  { to: "/projects", label: "Projects" },
  { to: "/contact", label: "Contact" },
];

const navTestId = (label) => `nav-${label.toLowerCase().replace(/\s|&/g, "-")}`;

function TopBar() {
  return (
    <div className="ye-topbar" data-testid="top-bar">
      <div className="ye-container" style={{ display: "flex", gap: 22, flexWrap: "wrap", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: 22, flexWrap: "wrap" }}>
          <a href="tel:+917689912984" data-testid="topbar-phone">
            <Phone size={14} style={{ display: "inline", marginRight: 6, verticalAlign: -2 }} />+91 76899 12984
          </a>
          <a href="mailto:yadurajenterprises9@gmail.com" data-testid="topbar-email">
            <Mail size={14} style={{ display: "inline", marginRight: 6, verticalAlign: -2 }} />yadurajenterprises9@gmail.com
          </a>
        </div>
        <span>
          <MapPin size={14} style={{ display: "inline", marginRight: 6, verticalAlign: -2 }} />Barmer, Rajasthan | New Delhi
        </span>
      </div>
    </div>
  );
}

function DesktopNav() {
  return (
    <nav className="ye-nav" aria-label="Primary">
      {NAV.map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          end={n.to === "/"}
          className={({ isActive }) => (isActive ? "active" : "")}
          data-testid={navTestId(n.label)}
        >
          {n.label}
        </NavLink>
      ))}
      <Link to="/contact" className="ye-btn ye-btn-primary" data-testid="header-cta-quote">Get a Quote</Link>
    </nav>
  );
}

function MobileNav() {
  return (
    <div className="ye-mobile-menu" data-testid="mobile-menu">
      {NAV.map((n) => (
        <NavLink
          key={n.to}
          to={n.to}
          end={n.to === "/"}
          className={({ isActive }) => (isActive ? "active" : "")}
          data-testid={`mobile-${navTestId(n.label)}`}
        >
          {n.label}
        </NavLink>
      ))}
      <Link to="/contact" className="ye-btn ye-btn-primary" data-testid="mobile-cta-quote">Get a Quote</Link>
    </div>
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Close mobile menu whenever the route changes.
  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <>
      <TopBar />
      <header className="ye-header" data-testid="site-header">
        <div className="ye-header-row">
          <Link to="/" className="ye-header-logo" aria-label="Yaduraj Enterprises — Home" data-testid="header-logo">
            <img src="/brand/yaduraj-logo-full-transparent.png" alt="Yaduraj Enterprises logo" />
          </Link>
          <DesktopNav />
          <button
            className="ye-mobile-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
        {open && <MobileNav />}
      </header>
    </>
  );
}

export function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/917689912984?text=Hello%20Yaduraj%20Enterprises%2C%20I%20want%20to%20discuss%20a%20project."
      target="_blank"
      rel="noopener noreferrer"
      className="ye-wa-float"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
    >
      <MessageCircle size={28} />
    </a>
  );
}
